import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { getFBAdPreview } from 'redux/modules/adBuilder';
import { parseLink } from 'redux/modules/parsedLinks';
import { IframePreview, PostPlatformPreview } from 'components';
var SchedulePostPreview = (_dec = connect(function (state, ownProps) {
  var _state$organization, _state$organization$s, _state$adBuilder;

  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    orgDetails: (_state$organization = state.organization) !== null && _state$organization !== void 0 && (_state$organization$s = _state$organization.selectedOrgDetails) !== null && _state$organization$s !== void 0 && _state$organization$s[orgId] ? state.organization.selectedOrgDetails[orgId] : null,
    orgAdBuilder: (_state$adBuilder = state.adBuilder) !== null && _state$adBuilder !== void 0 && _state$adBuilder[orgId] ? state.adBuilder[orgId] : {},
    parsedLinks: state.parsedLinks
  };
}, {
  getFBAdPreview: getFBAdPreview,
  parseLink: parseLink
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SchedulePostPreview, _Component);

  var _super = _createSuper(SchedulePostPreview);

  function SchedulePostPreview(props) {
    var _this;

    _classCallCheck(this, SchedulePostPreview);

    _this = _super.call(this, props);
    _this.state = {
      fbAdPreviewRendering: false
    };
    return _this;
  }

  _createClass(SchedulePostPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.post.type === 'AD') {
        this.setState({
          fbAdPreviewRendering: true
        });
        this.props.getFBAdPreview(this.props.organization.id, this.props.orgDetails.SocialAccounts.find(function (sa) {
          return sa.platform === 'Facebook page';
        }).id, 'DESKTOP_FEED_STANDARD', {
          adId: this.props.post.adId
        });
      } else if (this.props.post.postType === 'linkPost') {
        var _this$props, _this$props$parsedLin;

        if (!((_this$props = this.props) !== null && _this$props !== void 0 && (_this$props$parsedLin = _this$props.parsedLinks) !== null && _this$props$parsedLin !== void 0 && _this$props$parsedLin[this.props.post.linkUrl])) {
          this.props.parseLink(this.props.post.linkUrl);
        }
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var post = this.props.post;
      var videos = post.videoUrl && post.postType === 'videoPost' ? [post.videoUrl] : [];
      var linkData = this.props.post.postType === 'linkPost' && this.props.parsedLinks[post.linkUrl] ? this.props.parsedLinks[post.linkUrl] : null;
      return /*#__PURE__*/React.createElement("div", null, post.type === 'AD' ? /*#__PURE__*/React.createElement(React.Fragment, null, this.state.fbAdPreviewRendering && /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin",
        style: {
          fontSize: 24
        }
      })), /*#__PURE__*/React.createElement(IframePreview, _extends({
        style: {
          paddingLeft: 16,
          height: '100%'
        },
        iframeWidth: "100%",
        selectedPreviewTab: "DESKTOP_FEED_STANDARD",
        onLoad: function onLoad() {
          return _this2.setState({
            fbAdPreviewRendering: false
          });
        },
        organization: this.props.organization
      }, this.props.orgAdBuilder))) : /*#__PURE__*/React.createElement(PostPlatformPreview, {
        style: {
          margin: '0 auto',
          maxWidth: 527,
          paddingTop: 8,
          paddingBottom: 8,
          marginTop: 20
        },
        images: post.postType === 'linkPost' && linkData !== null && linkData !== void 0 && linkData.imageUrl ? [linkData.imageUrl] : post.images,
        messages: post.messages,
        link: post.linkUrl,
        linkTitle: linkData !== null && linkData !== void 0 && linkData.title ? "".concat(linkData.title.slice(0, 60), "...") : '',
        linkCaption: post.postType === 'linkPost' && post.linkUrl ? post.linkUrl.split('//')[1].split('/')[0] : '',
        platforms: post.platforms,
        postDate: post.publishAt ? moment(post.publishAt) : null,
        postType: post.postType,
        videos: post.videoUrl ? [post.videoUrl] : []
      }));
    }
  }]);

  return SchedulePostPreview;
}(Component)) || _class);
export default SchedulePostPreview;